import { useState, useEffect, useCallback } from 'react';
import { consignorService, distributionCenterService } from '../services';

export function useConsignorFilter() {
  const [isOwnerUser, setIsOwnerUser] = useState(false);
  const [consignors, setConsignors] = useState([]);
  const [selectedConsignor, setSelectedConsignor] = useState(undefined);
  const [consignorLoaded, setConsignorLoaded] = useState(false);

  useEffect(() => {
    consignorService.getInfo()
      .then((info) => {
        setIsOwnerUser(info.isOwner);
        if (info.isOwner) {
          return consignorService.getConsignorsList()
            .then((list) => {
              const data = list.map((item) => ({
                id: item.Id || item.id,
                name: item.Name || item.name,
              }));
              setConsignors(data);
              if (data.length > 0) {
                setSelectedConsignor(data[0].id);
              }
              setConsignorLoaded(true);
            });
        } else {
          setConsignorLoaded(true);
        }
      })
      .catch(() => setConsignorLoaded(true));
  }, []);

  const getCompaniesWithConsignor = useCallback(() => {
    const consignorId = isOwnerUser ? selectedConsignor : null;
    return distributionCenterService.getCompanies(false, false, consignorId);
  }, [isOwnerUser, selectedConsignor]);

  const onConsignorChange = useCallback((value, cb) => {
    setSelectedConsignor(value);
    if (cb) cb(value);
  }, []);

  return {
    isOwnerUser,
    consignors,
    selectedConsignor,
    consignorLoaded,
    setSelectedConsignor: onConsignorChange,
    getCompaniesWithConsignor,
  };
}